export default __webpack_public_path__ + "static/weel-homepage-animation-f65b4317331109ce7ca281366281dbfe.webm";